<template>
    <div v-if="stats">
        <div class="row" v-if="features.canEdit()">
            <div class="col-md-6 col-lg-5 col-xl-4">

                <progress-card :progress="stats.progress"
                    :tester="session.tester1"
                    class="mb-4"
                    v-if="showTester1"
                ></progress-card>
                
                <progress-card :progress="stats.progress"
                    :tester="session.tester2"
                    class="mb-4"
                    v-if="showTester2"
                ></progress-card>
                
                <completion-card :session="session" :progress="stats.progress"
                    @reload-session="reloadSessionAndFeedbacks"
                ></completion-card>
                
                <issues-card :session="session" :stats="stats"
                    @reload-session="$emit('reload-session')"
                ></issues-card>
            </div>
            <div class="col-md-6 col-lg-7 col-xl-8">
                
                <go-nogo-card :status="stats.status"
                    class="mb-4"
                ></go-nogo-card>
                
                <radar-card :evaluation="stats.evaluation"
                    class="mb-4"
                ></radar-card>
                
                <comments-card :title="$t('dashboard.general-comments')" :comments="stats.comments" :competencies="stats.evaluation">
                </comments-card>
                
                <feedbacks-card :title="$t('common.feedbacks')" :session="session" ref="feedbacks">
                </feedbacks-card>
            </div>
        </div>
        <div class="row" v-else>
            <div class="col-md-6 col-lg-5 col-xl-4">

                <go-nogo-card :status="stats.status"
                    class="mb-4"
                ></go-nogo-card>

            </div>
            <div class="col-md-6 col-lg-7 col-xl-8">
                
                <radar-card :evaluation="stats.evaluation"
                    class="mb-4"
                ></radar-card>

                <comments-card :title="$t('dashboard.general-comments')" :comments="stats.comments" :competencies="stats.evaluation">
                </comments-card>
                
                <feedbacks-card :title="$t('common.feedbacks')" :session="session" v-if="features.canSeeInstructionDetails()">
                </feedbacks-card>
            </div>
        </div>
    </div>
</template>

<script>
    import SessionFeatures from './SessionFeatures'
    import CompletionCard from './summary/CompletionCard'
    import IssuesCard from './summary/IssuesCard'
    import ProgressCard from './summary/ProgressCard'
    import RadarCard from './summary/RadarCard'
    import CommentsCard from './summary/CommentsCard'
    import FeedbacksCard from './summary/FeedbacksCard'
    import GoNogoCard from './summary/GoNogoCard'

    export default {

        components: {
            CompletionCard, IssuesCard, ProgressCard, RadarCard, CommentsCard, FeedbacksCard, GoNogoCard
        },

        props: {

            session: {
                type: Object,
                required: true
            },

            stats: {
                type: Object,
                required: true
            },
        },

        data() {
            return {
                features: new SessionFeatures(this.$router, this.$auth, this.session),
            }
        },

        computed: {

            showTester1() {
                if (!this.session.tester1) {
                    return false
                }
                if (!this.session.sync) {
                    return true
                }
                return this.session.tester1.id == this.$auth.user.id
            },

            showTester2() {
                if (!this.session.tester2) {
                    return false
                }
                if (!this.session.sync) {
                    return true
                }
                return this.session.tester2.id == this.$auth.user.id
            },
        },

        methods: {

            reloadSessionAndFeedbacks() {
                this.$emit('reload-session')
                this.$refs.feedbacks.list()
            }
        }
    }
</script>

